import { useMutation, UseMutationOptions, UseMutationResult } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { axiosInstance } from '@/axios';
import { responseHandler } from '@/utils';

interface UpdateUserLanguageRequest {
  userId: string;
  language: string;
}

type MutationParams = UpdateUserLanguageRequest;

export const useUpdateUserLanguage = (
  options?: UseMutationOptions<void, AxiosError, MutationParams>,
): UseMutationResult<void, AxiosError, MutationParams> => useMutation<void, AxiosError, MutationParams>({
  mutationFn: (data) => axiosInstance.put('/v3-updateUserLanguage', data, {
    headers: { 'Content-Type': 'application/json' },
  }).then(responseHandler),
  ...options,
});
